module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "mobile-header"
  }, [_c('a', {
    staticClass: "navbar-toggle",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('div', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "team-name",
    attrs: {
      "id": "team"
    }
  }, [_vm._v(_vm._s(_vm.team.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "header-nav"
  }, [(_vm.team) ? _c('li', [_c('a', {
    attrs: {
      "href": 'http://' + _vm.team.domain + '.slack.com/',
      "target": "_blank"
    }
  }, [_vm._v("Open Slack")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promo"
  }, [_c('a', {
    attrs: {
      "href": "https://slack-archives.org",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo logo-md",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "SlackArchives.org"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo logo-xs",
    attrs: {
      "src": require("../assets/logo-symbol.png"),
      "alt": "SlackArchives.org"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a10559d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 257
// module chunks = 2